import Issues from '../components/templates/issues';

export const IssuesContainer = () => {
  return <Issues />;
};
